import React from "react";
import { ExternalLink } from "lucide-react";

/**
 * ProfileSponsors — "Please Visit My Sponsors" affiliate-link strip.
 * Accepts either an array of plain URL strings or `{ url, title }`
 * objects (older + newer schemas coexist in production data).
 *
 * Props:
 *   links — array | undefined. Component renders null when missing/empty.
 */
export const ProfileSponsors = ({ links }) => {
  if (!Array.isArray(links) || links.length === 0) return null;
  return (
    <div className="mt-6 text-center">
      <p className="text-gray-600 text-xs mb-2">Please Visit My Sponsors</p>
      <div className="flex flex-wrap justify-center gap-2">
        {links.map((link, i) => {
          const url = typeof link === "object" ? link.url : link;
          const href = url.startsWith("http") ? url : `https://${url}`;
          const title = typeof link === "object" && link.title
            ? link.title
            : new URL(href).hostname;
          return (
            <a
              key={typeof link === "object" ? (link.url || i) : link}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-400 hover:text-emerald-300 flex items-center gap-1 bg-emerald-500/10 hover:bg-emerald-500/20 px-2 py-1 rounded-full text-xs transition-colors"
            >
              <ExternalLink className="h-3 w-3" /> {title}
            </a>
          );
        })}
      </div>
    </div>
  );
};
